import { Tooltip, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export interface CloseButtonProps {
    onClick: () => void;
}

export function CloseButton(props: CloseButtonProps) {
    return (
        <Tooltip title="Close">
            <IconButton
                aria-label="Close"
                onClick={props.onClick}
            >
                <CloseIcon />
            </IconButton>
        </Tooltip>
    );
}
